import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

import { StatusEnum } from '../../utils/utils';

export const UPDATE_PROJECT_STATUS = gql`
  mutation UpdateProject($id: Int!, $status: EProjectStatus!) {
    project {
      updateProjectStatus(id: $id, status: $status) {
        id
      }
    }
  }
`;

const updateProjectStatusRequest = ({
  id,
  status,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={UPDATE_PROJECT_STATUS}>
    {(updateProjectStatus, { loading, error, data }) => {
      let projectStatus;
      if (status === 0) {
        projectStatus = StatusEnum.INACTIVE;
      } else if (status === 1) {
        projectStatus = StatusEnum.ACTIVE;
      } else {
        projectStatus = StatusEnum.DELETED;
      }

      const variables = {
        id,
        status: projectStatus,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(id);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={updateProjectStatus}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

updateProjectStatusRequest.propTypes = {
  id: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  status: PropTypes.number.isRequired,
};

export default updateProjectStatusRequest;
